import React from 'react'
import { useTranslation } from "react-i18next"
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { SimpleLoading, VerifyContract, PromotionalFooterPure, CardTemplatePure, TitleTemplatePure, InformationADAkubicaFirmaDigitalInvitedPure } from '../../pures'
import './queries-and-validations-panel.css'

const QueriesAndValidationsPanelView = (props) => {
  const { t } = useTranslation()
  const longmatches = useMediaQuery('(max-width:1200px)')

  const globalContainerStyles = {
    display: 'inline-block',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    backgroundColor: 'white',
    width: '100%',
    // padding: '20px'
  }

  if (longmatches) {
    globalContainerStyles.marginRight = 0
  }

  const containerTableAndHeadersStyles = {
    marginTop: '20px',
    maxWidth: '100%',
    justifyContent: 'start',
  }

  return (
    <div>
      {(props.loading) ? <SimpleLoading /> : props.contractPlanExist ?
        <>
          {/* Table and Headers */}
          {props.userType !== 3 ?
            <Container es={12} style={globalContainerStyles} >
              <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                <TitleTemplatePure title={props.title} />
              </Grid>
              <Grid container xs={12} lg={12} md={12} sm={12} es={12} className='queriesValidations-container-header'>
                <Grid item xs={6} lg={12} md={12} sm={12} es={12} className='container-cards-queriesValidations-view'>
                  {props.cardQueriesValidations.map((item, index) =>
                    <div xs={8} lg={3} md={4} sm={6} className='card-queriesValidations'>
                      <CardTemplatePure {...item} key={index} />
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={containerTableAndHeadersStyles}>
                  <PromotionalFooterPure />
                </Grid>
              </Grid>
            </Container>
            :
            <Container es={12} style={globalContainerStyles} >
              <div className="table-queriesValidations" xs={12} lg={12} md={12} sm={12}>
                <h3 className="table-title-queriesValidations">{t('queriesAndValidationsPanelView.titleQueriesAndValidations')}</h3>
              </div>
              <Grid container className='queriesValidations-container' xs={12} lg={12} md={12} sm={12} es={12}>

                <Grid container xs={12} lg={12} md={12} sm={12} es={12} className='container-notification-invited'>
                  <Grid item xs={12} lg={10} md={10} sm={10}>
                    <div xs={12} lg={12} md={12} sm={12} es={12} className='btn-notificacions'>
                      <InformationADAkubicaFirmaDigitalInvitedPure
                        onInvitedRedirectRegister={props.onInvitedRedirectRegister}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} >
                <PromotionalFooterPure />
              </Grid>
            </Container>
          }

        </>
        : <Container spacing={4} lg={12} md={12} style={globalContainerStyles} > <VerifyContract /></Container>
      }
    </div>
  )
}

export { QueriesAndValidationsPanelView as default }
